/**
 * MobileNotice — displayed in PlaytesterView when the viewport is too narrow
 * for comfortable playtesting (< 1024px, i.e. below the "lg" breakpoint).
 */

export default function MobileNotice() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 text-center gap-4">
      <div className="w-16 h-16 rounded-full bg-orange-500/10 border border-orange-500/20 flex items-center justify-center text-orange-400 text-3xl">
        🖥
      </div>
      <div>
        <h2 className="text-lg font-bold text-gray-100 mb-2">Desktop Required</h2>
        <p className="text-sm text-gray-400 max-w-sm leading-relaxed">
          The playtester requires a screen width of at least 1024px. Please switch to a desktop or
          widen your browser window to use the playtester.
        </p>
      </div>
    </div>
  );
}
